import { API, ApiPrefixes } from "../api";

const BASE_URL = ApiPrefixes["memberManagement"];

export const adminMemberBankAccountApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberBankAccount: builder.query({
      query: (memberId) => ({
        url: `${BASE_URL}/${memberId}/bank_account?guard=staff`,
        method: "GET",
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, memberId) => [
        { type: "MemberBankAccount", id: memberId },
      ],
    }),

    addMemberBankAccount: builder.mutation({
      query: ({ memberId, ...body }) => ({
        url: `${BASE_URL}/${memberId}/bank_account/add?guard=staff`,
        method: "POST",
        body: body,
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (result, error, { memberId }) => [
        { type: "MemberBankAccount", id: memberId },
      ],
    }),

    editMemberBankAccount: builder.mutation({
      query: ({ memberId, bankAccountId, ...body }) => ({
        url: `${BASE_URL}/${memberId}/bank_account/${bankAccountId}/edit?guard=staff`,
        method: "PATCH",
        body: body,
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (result, error, { memberId }) => [
        { type: "MemberBankAccount", id: memberId },
      ],
    }),

    validateBankAccount: builder.mutation({
      query: ({ memberId, account_number, bank_code }) => ({
        url: `${BASE_URL}/${memberId}/bank_account/validate-account?guard=staff`,
        method: "POST",
        body: { account_number, bank_code },
      }),
      transformResponse: (responseData) => responseData?.data,
    }),

    deleteMemberBankAccount: builder.mutation({
      query: ({ memberId, bankAccountId }) => ({
        url: `${BASE_URL}/${memberId}/bank_account/${bankAccountId}/delete?guard=staff`,
        method: "DELETE",
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (result, error, { memberId }) => [
        { type: "MemberBankAccount", id: memberId },
      ],
    }),
  }),
});

export const {
  useGetMemberBankAccountQuery,
  useAddMemberBankAccountMutation,
  useEditMemberBankAccountMutation,
  useValidateBankAccountMutation,
  useDeleteMemberBankAccountMutation,
} = adminMemberBankAccountApi;
